<app-tabs-header [labelText]="'Search for a limit by name'"
                 [iconName]="'add'"
                 [showButton]="true"
                 [buttonText]="'Add Limit'"
                 (valueChanged)="onValueChanged($event)"
                 (emitClickEvent)="openLimitDialog()">
</app-tabs-header>

<div *ngIf="limitsDataSource" class="mat-elevation-z8 table-container">

  <table mat-table multiTemplateDataRows [dataSource]="limitsDataSource"
         matSort (matSortChange)="sortData($event)">
    <ng-container matColumnDef="icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <mat-icon class="table-icon" matTooltip="EDIT Limit"
                  (click)="editEntry($event, row.limitId)">
          edit
        </mat-icon>
        <mat-icon class="table-icon" matTooltip="DELETE Limit"
                  (click)="onDeleteLimitConfirmation($event, row)">
          delete
        </mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="limitId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
      <td *matCellDef="let row" mat-cell>{{row.limitId}}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
      <td *matCellDef="let row" mat-cell>{{row.name}}</td>
    </ng-container>

    <ng-container matColumnDef="limitType">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Type</th>
      <td *matCellDef="let row" mat-cell>{{row.limitType?.name}}</td>
    </ng-container>

    <ng-container matColumnDef="measure">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Measure</th>
      <td *matCellDef="let row" mat-cell>{{row.measure?.name}}</td>
    </ng-container>

    <ng-container matColumnDef="accumulateBy">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Accumulate By</th>
      <td *matCellDef="let row" mat-cell>{{row.accumulateBy?.name}}</td>
    </ng-container>

    <ng-container matColumnDef="accumulateAt">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Accumulate At</th>
      <td *matCellDef="let row" mat-cell>{{row.accumulateAt?.name }}</td>
    </ng-container>

    <ng-container matColumnDef="value">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Value</th>
      <td *matCellDef="let row" mat-cell>{{row.value}}</td>
    </ng-container>

    <ng-container matColumnDef="startDate">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
      <td *matCellDef="let row" mat-cell>{{row.startDate | date: dateFormat}}</td>
    </ng-container>

    <ng-container matColumnDef="endDate">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
      <td *matCellDef="let row" mat-cell>{{row.endDate | date: dateFormat}}</td>
    </ng-container>

    <!-- Expanded Row -->
    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="limitsDisplayedColumns.length">
        <div class="row-detail-container"
             [@detailExpand]="row == limitsExpandedRow ? 'expanded' : 'collapsed'">
          <b>Created By: </b>{{row.createdBy}}<br>
          <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
          <b>Updated By: </b>{{row.updatedBy}}<br>
          <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
        </div>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="limitsDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: limitsDisplayedColumns;"
        class="row" [class.expanded-row]="limitsExpandedRow == row"
        (click)="limitsExpandedRow = limitsExpandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
  </table>

  <mat-paginator #limitsPaginator (page)="pageChanged($event)"
                 [length]="limitsTableControl.length" [pageSize]="limitsTableControl.pageSize"
                 [pageIndex]="0" [pageSizeOptions]="limitsTableControl.pageSizeOptions">
  </mat-paginator>
</div>
